
export enum CreationCode {
    Debug = 0,
    VehicleMovingOverTime = 1,
    VehicleMovingOverDistance = 2,
    VehicleIdling = 3,
    KeyON = 4,
    KeyOFF = 5,
    HeadingChange = 10,
    TwentyFourHour = 24,
    GPSGot = 25,
    GPSLost = 26,
    VehicleStartMoving = 29,
    MotionOnKeyOff = 42,
    MotionStopOnKeyOff = 43,
    CameraButton = 55,
    DriverLogon = 61,
    DriverLogoff = 62,
    EngineON = 74,
    EngineOFF = 75,
    Error = 91,
    GPSQualityFix = 94,
    GPSQualityLost = 95,
    Heartbeat = 100,
    WakeupOnMotion = 101,
    VehicleStationary = 123,
    GPSModemRestart = 200,
    FileManagerSuccess = 400,
    FileManagerFailure = 401,
    HarshUnknownHigh = 435,
    HarshDecelHigh = 436,
    HarshAccelHigh = 437,
    HarshCornerHigh = 438,
    RSPST1Video = 455,
    RSPST2Video = 456,
    HarshUnknownLow = 457,
    HarshUnknownMedium = 458,
    VideoRequestedEvent = 459,
    VideoUploadComplete = 460,
    AppbootupUpdater = 470,
    AppbootupTelematics = 471,
    LaneDepartureLeft = 480,
    LaneDepartureRight = 481,
    PedestrianCollisionWarning = 482,
    VehicleTooCloseWarning = 483,
    VehicleCollisionWarning = 484,
    CameraCovered = 485,
    DriverLogoutAbnormality = 486,
    DriverLogin = 487,
    EyesCovered = 488,
    EyesClosed = 489,
    FatigueBlinking = 490,
    Yawning = 491,
    StaringLeftRight = 492,
    GlancingLeftRight = 493,
    LookingUpDown = 494,
    PhoneCalling = 495,
    PhoneWatching = 496,
    Smoking = 497,
    LowMedvideoRequestedEvent = 500
}
